import styled from "@emotion/styled";
import theme from "@theme";

const Input = styled.input`
  padding: 6px;
  border: 1px solid #e2e4e7;
  border-radius: 3px;
  transition: border-color 0.3s;
  outline: none;
  &:hover {
    border-color: #1976d2;
  }

  &:focus {
    border-color: #1976d2;
  }
`;

const Select = styled.select`
  padding: 5px;
  border: 1px solid #e2e4e7;
  border-radius: 3px;
  transition: border-color 0.3s;
  outline: none;

  &:hover {
    border-color: #1976d2;
  }

  &:focus {
    border-color: #1976d2;
  }
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 1;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 15px 8px 15px;
`;

const Children = styled.div`
  flex: 2;
`;

const SelectWrapper = styled.div`
  width: 250px;
  margin-left: 20px;
`;

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.span`
  font-size: 17px;
  color: white;
  font-weight: normal;
`;

const Form = styled.form`
  padding: 15px 0px 20px 5px;
  max-width: 600px;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
  width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 40px;
`;
const ValidtionMessages = styled.p`
  color: gray;
  font-size: 10px;
  padding-block: 0px;
  margin-block: 0px;
`;

const SC = {
  Input,
  Select,
  Label,
  LabelContainer,
  Children,
  SelectWrapper,
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  Form,
  FormWrapper,
  Astrik,
  Wrapper,
  ButtonContainer,
  ValidtionMessages,
};

export default SC;
